export enum COUNTER_TYPES {
  COUNTER_TYPE_PROFILE_DETAIL = 2,
  COUNTER_TYPE_PROFILE_HOMEPAGE = 5,
  COUNTER_TYPE_PROFILE_EMAIL = 6,
  COUNTER_TYPE_PROFILE_RATING_LIST = 9,
  COUNTER_TYPE_PROFILE_SOCIAL_MEDIA = 11,
  COUNTER_TYPE_PROFILE_PHONE = 12,
  COUNTER_TYPE_PROFILE_LAW_OFFICE = 21,
  COUNTER_TYPE_LAW_OFFICE_RELATED_PROFILES = 22,
  COUNTER_TYPE_PROFILE_ARTICLE_LIST = 7,
}

export const MAP_APP_COUNTER_TYPE: Record<string, COUNTER_TYPES> = {
  'anw-rating-detail': COUNTER_TYPES.COUNTER_TYPE_PROFILE_RATING_LIST,
  'anw-profile-details': COUNTER_TYPES.COUNTER_TYPE_PROFILE_DETAIL,
  'anw-article-detail': COUNTER_TYPES.COUNTER_TYPE_PROFILE_ARTICLE_LIST,
};
